import { render, staticRenderFns } from "./b-popup-customer-follow-up-detail.vue?vue&type=template&id=f5880ecc&scoped=true"
import script from "./b-popup-customer-follow-up-detail.vue?vue&type=script&lang=js"
export * from "./b-popup-customer-follow-up-detail.vue?vue&type=script&lang=js"
import style0 from "./b-popup-customer-follow-up-detail.vue?vue&type=style&index=0&id=f5880ecc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5880ecc",
  null
  
)

export default component.exports